import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "The chronicles of a dead blog",
  "description": "",
  "published": "2008-05-06T00:00:00.000Z",
  "redirect_from": ["/blog/the-chronicles-of-a-dead-blog/swizec/116"],
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`This blog has been dead for a month it would seem. Not my fault, well it is, but let's pretend it's not, I was just too arrogant to put quite anything on here and I guess I didn't have any ideas deemed worthwhile to blog about. Fuck it, it happens.`}</p>
    <p>{`Before I vanished into the ether of real life this website had about 300 hits over the period of "last 30 days" on google analytics when I blogged nearly every day, now it has about 200 ... which is kind of surprising seeming as how there was nothing here for a while. You'd think people would go away, but apparently they kept hoping. So everyone still hoping and reading this now, you can tell all the rest of your hundred buddies that I'll now make a real effort to blog more. A real one, not a fake one. A really real one, honest.`}</p>
    <p>{`See the thing that's hampering me down the most is that many people know about this blog and some of them don't have the security clearance to know some things and so there's less topics to talk about. I also find it a bit dull to just talk about my day to day life, that's not blogging, that's being boring.`}</p>
    <p>{`So uhm ... yes that's it for now. I'm at work actually, listening to `}<a parentName="p" {...{
        "href": "http://youtube.com/watch?v=eELH0ivexKA"
      }}>{`Cup of Brown Joy`}</a>{` over a cup of brown joy. Cheery oh.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      